"use client";

import * as icons from "@template/icons";

export interface DynamicIconProps {
  name?: string;

  [key: string]: any;
}

const DynamicIcon = ({ name, ...props }: DynamicIconProps) => {
  if (!name) return null;
  const IconComponent = name ? (icons as any)[name] : null;

  if (!IconComponent) {
    return <div>Icon not found</div>;
  }

  return <IconComponent {...props} />;
};
export default DynamicIcon;
